var exports = {
  "fi": "HistoryList__dJellX",
  "Sb": "HistoryVersionContent__PALlYh",
  "vj": "HistoryVersionLabel__8UuUeY",
  "em": "HistoryVersionMetadata__fFp0Hq",
};

module.exports = exports;
